export default __webpack_public_path__ + "images/slide_8.jpeg?3eb481d00d30e645ca15a72783c990af";